module.exports = __webpack_public_path__ + "img/pre-banner-bottom.b1412730.svg";